import { FormatLabelFn } from '@@partner:types:app'

import {
  RECEIPT_STATUS_DONE,
  RECEIPT_STATUS_WAIT,
  RECEIPT_STATUS_FAIL,
  RECEIPT_TYPE_PREPAYMENT,
  RECEIPT_TYPE_FULLPAYMENT,
  RECEIPT_TYPE_PREPAYMENT_REFUND,
  RECEIPT_TYPE_REFUND
} from '@@partner:config/order-payment-status-codes'

/*
  Get order receipts info
*/

export const formatOrderReceiptsStatus: FormatLabelFn<string> = (value) => {
  switch (value) {
  case RECEIPT_STATUS_DONE:
    return { label: 'Успешно', color: 'green' }
  case RECEIPT_STATUS_FAIL:
    return { label: 'Ошибка', color: 'red' }
  case RECEIPT_STATUS_WAIT:
    return { label: 'Ожидание', color: 'violet' }
  default:
    return { label: value, color: 'red' }
  }
}

export const formatOrderReceiptsType: FormatLabelFn<string> = (value) => {
  switch (value) {
  case RECEIPT_TYPE_PREPAYMENT:
    return { label: 'Предоплата (аванс)', color: 'blue' }
  case RECEIPT_TYPE_FULLPAYMENT:
    return { label: 'Финальный чек', color: 'green' }
  case RECEIPT_TYPE_PREPAYMENT_REFUND:
    return { label: 'Возврат предоплаты', color: 'violet' }
  case RECEIPT_TYPE_REFUND:
    return { label: 'Возврат', color: 'red' }
  default:
    return { label: 'Неизвестный статус платежа', color: 'yellow' }
  }
}
